import { Model, hasMany, belongsTo } from 'miragejs';

export default Model.extend({
  // Mirage needs to behave like the real API. There is no `skinny-locations`
  // concept there, so we need to overwrite the relation here.
  signInFieldActionRuleGroups: hasMany(),
  locations: hasMany('location', { inverse: null }),
  location: belongsTo(),
  signInFieldPage: belongsTo(),
  badge: belongsTo(),
  agreementPage: belongsTo(),
  summaryPage: belongsTo(),
  photoPage: belongsTo(),
  idScanPage: belongsTo(),
  visualComplianceConfiguration: belongsTo(),
  globalFlow: belongsTo(),
  visitorDocumentContacts: hasMany('user'),
  userDocumentTemplateConfigurations: hasMany(),
  activeUserDocumentTemplateConfigurations: hasMany('userDocumentTemplateConfigurations'),
  inviteApprovalContacts: hasMany('user'),
});
